import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgA1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_1442)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.0541 143C41.5741 143 41.1741 142.84 40.8541 142.52C40.5341 142.147 40.3741 141.747 40.3741 141.32C40.3741 141.053 40.4007 140.813 40.4541 140.6L59.4941 89.16C59.6541 88.5733 59.9741 88.0667 60.4541 87.64C60.9341 87.2133 61.6007 87 62.4541 87H72.6941C73.5474 87 74.2141 87.2133 74.6941 87.64C75.1741 88.0667 75.4941 88.5733 75.6541 89.16L94.6941 140.6C94.7474 140.813 94.7741 141.053 94.7741 141.32C94.7741 141.747 94.6141 142.147 94.2941 142.52C93.9741 142.84 93.5741 143 93.0941 143H84.7741C83.9741 143 83.3874 142.813 83.0141 142.44C82.6407 142.067 82.4007 141.72 82.2941 141.4L78.8541 132.44H56.2941L52.8541 141.4C52.7474 141.72 52.5074 142.067 52.1341 142.44C51.7607 142.813 51.1741 143 50.3741 143H42.0541ZM59.2541 122.12H75.8141L67.5741 99.08L59.2541 122.12ZM114.465 143C113.931 143 113.451 142.813 113.025 142.44C112.651 142.067 112.465 141.587 112.465 141V101.24L100.945 110.12C100.465 110.493 99.958 110.627 99.4247 110.52C98.9447 110.413 98.518 110.12 98.1447 109.64L94.1447 104.44C93.8247 103.96 93.6914 103.453 93.7447 102.92C93.8514 102.387 94.1447 101.96 94.6247 101.64L112.865 87.56C113.185 87.3467 113.478 87.2133 113.745 87.16C114.065 87.0533 114.411 87 114.785 87H123.265C123.798 87 124.251 87.1867 124.625 87.56C124.998 87.9333 125.185 88.4133 125.185 89V141C125.185 141.587 124.998 142.067 124.625 142.44C124.251 142.813 123.798 143 123.265 143H114.465Z",
					fill: "#27CCBC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.5,
					cy: -.5,
					r: 56.5,
					fill: "#BFEFEA"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 32.5,
					cy: 216.5,
					r: 56.5,
					fill: "#BFEFEA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_1442",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgA1;
